<template>
  <div :class="['slider', 'slider--' + variant]">
    <div
      v-if="variant !== 'timeline' && variant !== 'search' && variant !== 'header'"
      class="slider__title"
    >
      {{ searchInputStatus === 'active' ? 'Selected' : 'Filters' }} <span>({{ filtersCount }})</span>
    </div>

    <div
      :class="['slider__button', 'slider__button--' + variant, 'slider__button--left', leftActive ? '' : 'slider__button--inactive']"
      @click="pushFilters('toRight')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>

    <div
      ref="filterSlider"
      id="filterSlider"
      class="slider__content"
      @mousedown="pushed = false"
      @touchstart="pushed = false"
    >
      <div
        ref="filterSliderItems"
        id="filterSliderItems"
        :class="['slider__filters', pushed ? 'slider__filters--transition' : '']"
        :style="'margin-left:' + drag.current + 'px'"
      >
        <transition-group
          name="slider__transition"
          tag="div"
          appear
        >
          <template v-for="item in sliderItems">
            <UtilityItem
              v-if="variant === 'highlights'"
              :ref="'filterSliderItem--' + item.id"
              :key="'FILTER_SLIDER_ITEM_A--' + item.id"
              :resultId="item.id"
              type="pdfs"
              :licensed="true"
              @clicked="toggleItem(item)"
              @highlighted="highlightItem(item.name)"
              @downplayed="downplayItem(item.name)"
            />
            <!-- :licensed="results.byId[resultId].attributes.licensed" -->
            <UtilitySliderItem
              v-else
              :ref="'filterSliderItem--' + item.id"
              :key="'FILTER_SLIDER_ITEM_B--' + item.id"
              class="slider__transition-itemx"
              :type="item.type"
              :value="item"
              @clicked="variant === 'timeline' || variant === 'legend' ? toggleItem(item) : removeFilter(item)"
              @highlighted="highlightItem(item.name)"
              @downplayed="downplayItem(item.name)"
            />
          </template>
        </transition-group>
      </div>
    </div>

    <div
      :class="['slider__button', 'slider__button--' + variant, 'slider__button--right', rightActive ? '' : 'slider__button--inactive']"
      @click="pushFilters('toLeft')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>
  </div>
</template>

<script>
import UtilityItem from '@/components/utility/Item.vue'
import UtilitySliderItem from '@/components/utility/SliderItem.vue'

export default {
  components: {
    UtilityItem,
    UtilitySliderItem
  },
  props: {
    variant: {
      type: String,
      default: 'highlights'
    },
    filters: {
      type: Object,
      default: function () {
        return {}
      }
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    results: {
      type: Object,
      default: function () {
        return {}
      }
    },
    unselectedItems: {
      type: Array,
      default: function () {
        return []
      }
    },
    colors: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      mounted: false,
      pushed: false,
      drag: {
        current: 0,
        x: 0,
        dragging: false,
        preventToggle: false
      }
    }
  },
  computed: {
    searchInputStatus () {
      return this.$store.getters['search/getSearchInputStatus']
    },
    filtersCount () {
      let count = 0

      for (const [key, value] of Object.entries(this.filters)) {
        let filterCount = Object.keys(value).length
        count += filterCount
      }

      return count
    },
    sliderItems () {
      let items = []

      if (this.variant === 'highlights') {
        if(this.results.allIds && this.results.allIds.length > 0) {
          for (const [key, hash] of Object.entries(this.results.allIds)) {
            let newItem = { 'id': this.results.byId[hash].id, 'name': this.results.byId[hash].attributes.title, 'type': 'highlights', 'disabled': false }
            items.push(newItem)
          }
        }
      } else if (this.variant === 'timeline') {
        this.items.forEach(item => {
          let newItem = { 'id': item.name, 'name': item.name, 'type': 'timeline', 'disabled': item.disabled }
          items.push(newItem)
        })
      } else if (this.variant === 'legend') {
        let i = 0

        this.items.forEach(item => {
          let colorIndex = i

          while (colorIndex >= this.colors.length) {
            if (colorIndex >= this.colors.length) {
              colorIndex = colorIndex - this.colors.length
            }
          }

          let newItem = { 'id': item.name, 'name': item.name, 'color': this.colors[colorIndex], 'type': 'legend', 'disabled': this.unselectedItems.includes(item.name) ? true : false }
          items.push(newItem)
          i++
        })
      } else {
        for (const [groupKey, group] of Object.entries(this.filters)) {
          for (const [key, filter] of Object.entries(group)) {
            items.push(filter)
          }
        }
      }

      return items
    },
    leftActive () {
      if (this.mounted) {
        let check = this.drag.current < 0 ? true : false
        return check
      }

      return true
    },
    rightActive () {
      if (this.mounted) {
        let check = (this.$refs.filterSliderItems.offsetWidth + this.drag.current) > this.$refs.filterSlider.clientWidth ? true : false
        return check
      }

      return true
    }
  },
  methods: {
    removeFilter (value) {
      if ((this.$refs.filterSliderItems.offsetWidth + this.drag.current) <= this.$refs.filterSlider.clientWidth) {
        let filterWidth = this.$refs['filterSliderItem--' + value.id][0].$el.offsetWidth
        this.dragFilters(filterWidth + 8)
      }

      this.$emit('removeFilter', value)
    },
    toggleItem (value) {
      this.$emit('toggledItem', value)
    },
    highlightItem (value) {
      this.$emit('highlightedItem', value)
    },
    downplayItem (value) {
      this.$emit('downplayedItem', value)
    },
    pushFilters (direction) {
      let newXPos = 0

      if (direction === 'toLeft') {
        newXPos = this.drag.x - this.$refs.filterSlider.clientWidth + 40
      } else if (direction === 'toRight') {
        newXPos = this.drag.x + this.$refs.filterSlider.clientWidth - 40
      }

      this.dragFilters(newXPos)
      this.pushed = true
    },
    dragFilters (xPos) {
      if (this.$refs.filterSliderItems.offsetWidth > this.$refs.filterSlider.clientWidth) {
        if (this.drag.current + xPos - this.drag.x > 0) {
          this.drag.current = 0
          this.drag.x = xPos
        } else if (this.drag.current + xPos - this.drag.x < this.$refs.filterSlider.clientWidth - this.$refs.filterSliderItems.offsetWidth) {
          this.drag.current = this.$refs.filterSlider.clientWidth - this.$refs.filterSliderItems.offsetWidth
          this.drag.x = xPos
        } else {
          this.drag.current = this.drag.current + xPos - this.drag.x
          this.drag.x = xPos
        }
      }
    }
  },
  mounted () {
    document.getElementById('filterSlider').addEventListener('mousedown', e => {
      this.drag.x = e.clientX
      this.drag.dragging = true
      let that = this

      setTimeout(function () {
        if (that.drag.dragging === true) {
          that.drag.preventToggle = true
        }
      }, 500)
    }, { passive: true})

    document.getElementById('filterSlider').addEventListener('touchstart', e => {
      if (e.targetTouches[0]) {
        this.drag.x = e.targetTouches[0].pageX
        this.drag.dragging = true
      }
    }, { passive: true})

    window.addEventListener('mousemove', e => {
      if (this.drag.dragging === true) {
        this.dragFilters(e.clientX)
      } else {
        this.drag.preventToggle = false
      }
    }, { passive: true})

    window.addEventListener('mouseup', e => {
      if (this.drag.dragging === true) {
        this.dragFilters(e.clientX)
        this.drag.x = 0
        this.drag.dragging = false
        let that = this

        setTimeout(function () {
          that.drag.preventToggle = false
        }, 10)
      }
    }, { passive: true})

    window.addEventListener('touchmove', e => {
      if (e.targetTouches[0]) {
        if (this.drag.dragging === true) {
          this.dragFilters(e.targetTouches[0].pageX)
        } else {
          this.drag.preventToggle = false
        }
      }
    }, { passive: true})

    window.addEventListener('touchend', e => {
      if (e.targetTouches[0]) {
        if (this.drag.dragging === true) {
          this.dragFilters(e.targetTouches[0].pageX)
          this.drag.x = 0
        }
      }
      this.drag.dragging = false
    }, { passive: true})

    this.mounted = true
  },
  unmounted () {
    window.removeEventListener('mousedown', this.nextItem)
    window.removeEventListener('mouseup', this.nextItem)
    window.removeEventListener('mousemove', this.nextItem)
    window.removeEventListener('touchstart', this.nextItem)
    window.removeEventListener('touchend', this.nextItem)
    window.removeEventListener('touchmove', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.slider {
  @include font('content--sm');
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  width: 100%;
  //height: 36px;
  user-select: none;

  &:hover {
    .slider__button, .slider__content {
      fill: rgba($white, 0.1);
    }

    .slider__button:not(.slider__button--inactive), .slider__content {
      fill: rgba($white, 0.7);
    }
  }

  &--timeline, &--legend {
    text-align: center;
  }

  &--search {
    background-color: $bg-1;

    &:hover {
      .slider__button, .slider__content {
        background-color: $bg-2;
      }

      .slider__button:not(.slider__button--inactive), .slider__content {
        background-color: $bg-2;
      }
    }
  }

  &--header {
    background-color: $bg-2;

    &:hover {
      .slider__button, .slider__content {
        background-color: $bg-1;
      }

      .slider__button:not(.slider__button--inactive), .slider__content {
        background-color: $bg-1;
      }
    }
  }

  &__title {
    text-transform: uppercase;
    color: rgba($white, 0.7);
    margin-right: 4px;
    display: none;

    span {
      color: rgba($white, 0.5);
    }

    @media screen and (min-width: $breakpointMd) {
      display: block;
    }
  }

  &__button {
    display: flex;
    border-radius: 999px;
    align-items: center;
    user-select: none;
    padding: 7px 8px 9px 8px;
    transition: background-color 0.2s ease-out;

    &:hover:not(.slider__button--inactive) {
      fill: $white !important;
      cursor: pointer;

      svg {
        transform: scale(1.15);
      }
    }

    &:focus, &:active {
      svg {
        transform: scale(1) !important;
      }
    }

    &--search {
      background-color: $bg-1;
      fill: $bg-2;
    }

    &--legend {
      background-color: $bg-4;
      fill: $bg-2;
    }

    &--header {
      background-color: $bg-2;
      fill: $bg-4;
    }

    &--timeline {
      background-color: $bg-4;
      fill: $bg-2;
    }

    &--left.slider__button--search {
      transform: rotate(270deg);
      margin: 0px 6px 0px 2px;

      @media screen and (min-width: $breakpointLg) {
        margin-right: 7px;
      }
    }

    &--right.slider__button--search {
      transform: rotate(90deg);
      margin: 0px 6px;

      @media screen and (min-width: $breakpointLg) {
        margin: 0px 7px;
      }
    }

    &--left.slider__button--header, &--left.slider__button--timeline, &--left.slider__button--legend {
      transform: rotate(270deg);
      margin: 0px 2px 0px 6px;

      @media screen and (min-width: $breakpointLg) {
        margin-right: 7px;
      }
    }

    &--right.slider__button--header, &--right.slider__button--timeline, &--right.slider__button--legend {
      transform: rotate(90deg);
      margin: 0px 6px 0px 2px;

      @media screen and (min-width: $breakpointLg) {
        margin: 0px 7px;
      }
    }

    svg {
      transition: fill 0.2s ease-out;
      width: 14px;
      height: 14px;

      @media screen and (min-width: $breakpointLg) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__content {
    position: relative;
    z-index: 5;
    flex: 1;
    //height: 36px
    display: flex;
    justify-content: center;
    overflow: hidden;
    white-space: nowrap;
    border-radius: 999px;
    transition: background-color 0.2s ease-out;
    cursor: col-resize;
  }

  &__filters {
    height: 36px;
    display: inline-flex;
    align-items: center;

    &--transition {
      transition: margin 0.5s ease-in-out;

      @media screen and (min-width: $breakpointSm) {
        transition: margin 0.6s ease-in-out;
      }

      @media screen and (min-width: $breakpointMd) {
        transition: margin 0.7s ease-in-out;
      }

      @media screen and (min-width: $breakpointLg) {
        transition: margin 0.8s ease-in-out;
      }
    }
  }
}

.slider__transition-item {
  display: inline-block;
}
.slider__transition-enter-active, .slider__transition-leave-active {
  transition: all 0.5s;
}
.slider__transition-enter, .slider__transition-leave-to /* .list-leave-active below version 2.1.8 */ {
  //transform: scale(0.1);
  opacity: 0;
}
.slider__transition-move {
  transition: transform 0.5s;
}
.slider__transition-leave-active {
  position: absolute;
}



.list-complete-item {
  transition: all 1s;
  display: inline-block;
  //margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
